app.service('semanticUIService', [function () {
    return {
        load: function (module, selector, config) {
            var self = this;
            if (angular.isArray(module)) {
                module.forEach(function (entry) {
                    self.load(entry); // si array : selecteur / config par defaut
                });
            } else {
                if (selector && selector.constructor === Array) {
                    selector.forEach(function (entry) {
                        self.load(module, entry);
                    });
                } else if (selector && selector.constructor === Object) {
                    for (var i in selector) {
                        if (selector.hasOwnProperty(i)) {
                            self.load(module, i, selector[i]);
                        }
                    }
                } else {
                    switch (module) {
                        case 'tab':
                            if (angular.isUndefined(config)) {
                                config = {};
                            }
                            if (angular.isUndefined(selector)) {
                                selector = '.tabular.menu .item';
                            }
                            return $(selector).tab(config);
                        case 'sticky':
                            if (angular.isUndefined(config)) {
                                config = {};
                            }
                            if (angular.isUndefined(selector)) {
                                selector = '.ui.sticky';
                            }
                            return $(selector).sticky(config);
                        case 'vertical-menu-toggle':
                            $('.ui.vertical.menu').toggle();
                            break;
                        case 'dropdown':
                            var dropdownConfig = {
                                fullTextSearch: true
                            };
                            if (angular.isDefined(config)) {
                                dropdownConfig = config;
                            }
                            if (angular.isUndefined(selector)) {
                                selector = '.ui.dropdown';
                            }
                            var $elm = $(selector);
                            if (!$elm || !$elm.length) {
                                return null;
                            }
                            $elm.dropdown(dropdownConfig);
                            return $elm;
                        case 'checkbox':
                            if (angular.isUndefined(selector)) {
                                selector = '.ui.checkbox';
                            }
                            return $(selector).checkbox(config);
                        case 'toggle':
                            $('.ui.toggle.checkbox').checkbox();
                            break;
                        case 'radio':
                            $('.ui.radio.checkbox').checkbox();
                            break;
                        case 'tooltip':
                            if (angular.isUndefined(selector)) {
                                selector = '.ui.tooltip';
                            }
                            $(selector).popup();
                            break;
                        case 'accordion':
                            if (angular.isUndefined(selector)) {
                                selector = '.ui.accordion';
                            }
                            var $accordion = $(selector);
                            if ($accordion && $accordion.length) {
                                $accordion.accordion(angular.isDefined(config) ? config : {});
                            }
                            return $accordion;
                        case 'message':
                            if (angular.isDefined(selector)) {
                                $(selector + ' .close').on('click', function () {
                                    $(this).closest(selector).transition('fade');
                                });
                            } else {
                                $('.message .close').on('click', function () {
                                    $(this).closest('.message').transition('fade');
                                });
                            }
                            break;
                        case 'modal':
                            var $el = $(angular.isDefined(selector) ? selector : '.ui.modal');
                            if ($el && $el.length) {
                                $el
                                    .modal(angular.isDefined(config) ? config : {})
                                    .modal('show');
                            }
                            return $el;
                        case 'visibility':
                            var DEFAULT_OPTIONS = {
                                type: 'image',
                                transition: 'fade in',
                                duration: 500
                            };
                            config = Object.assign({}, DEFAULT_OPTIONS, angular.isDefined(config) ? config : {});
                            $(angular.isDefined(selector) ? selector : 'img').visibility(config);
                            break;
                        default:
                    }
                }
            }
        },

        reload: function (module, selector, config) {
            this
                .destroy(module, selector)
                .load(module, selector, config);
        },

        destroy: function (module, selector) {
            var $el = $(selector);
            if ($el && $el.length && $el[module] && $el[module].constructor === Function) {
                $el[module] = null;
            }
            return this;
        }
    };
}]);
